<template>
		<section class='knd-thema' ref='scroll'>

			<article class='knd-container'>
				<div 
					data-topic='THEMA' 
					v-if="number === 0" 
					:data-title="story.Title" 
					data-step="INTRO"
					class='knd-step knd-step__explainer' >
					<div class="knd-step__inner">
						<p>
							In deze grafiek staat voor elke gemeente een stip. De grootte van de stip stelt het aantal inwoners voor. Op de horizontale as staan de bedragen per inwoner: hoe meer naar rechts, hoe meer een gemeente uitgeeft. Als meerdere gemeenten hetzelfde bedrag uitgeven duwen de stippen elkaar naar boven. 		
						</p>		
					</div>
				</div>
			</article>

			<div class='knd-thema-title m-b-lg'>
				<div class=' knd-thema-title__container'>
					<div class='knd-thema-title__inner'>
						{{master.lasten_labels[title]}}
					</div>
				</div>
			</div>

			<article class='knd-container' >

				<div v-for="(block, index) in story.stepper"
						:key="title + '-' + index"
						class="knd-step" 
						:data-title="story.Title" 
						:data-count="number"
						data-topic='THEMA' 
						:data-step="block.step"
						>
						<div class="knd-step__inner">
							<h3 class='knd-step__title' v-if="block.Title">{{block.Title}}</h3>
							<div v-html="output_text(block.content)"></div>

							<div v-if="block.step === 'GEMEENTE'" class="knd-step__graphic p-t-md">
								<svg ref='graphic' width="90%" height="300px">
								</svg>
							</div>
						</div>
				</div>

				<div class='knd-step step__interactive' data-topic='SELECTEER' data-step="KLIK" >
					<div class='knd-step__inner'>
						klik op een onderwerp om er meer over te lezen
					</div>
				</div>

			</article>
		</section>
</template>

<script>

import scrollama from "scrollama";
import LineChart from './line.chart';
import * as d3 from 'd3';

export default {
	name: 'Thema',
	props: ['title', 'label', 'number'],
	data: function() {
		return {
			first: true
		}
	},
	components: {},
	beforeMount: function() {
		this.story = this.$store.getters.getThemaContent(this.title);
	},

	computed: {
		gemeente:function(){
			return this.$store.getters.selectedGemeente;
		},

		master:function(){
			return this.$store.getters.getMaster;
		} 

	},

	mounted: function() {
		this.initScrollama();

		this.renderGraphic()
	},

	methods: {
		renderGraphic() {

			let lasten = this.gemeente.lasten;

			let data = [];

			for (const key in lasten) {
				data.push({label: +key.replace('jaar_', ''), value: +lasten[key][this.title]})
			}

			data.sort((a,b)=>a.label-b.label)

			const stepWidth = document.querySelector(".knd-step__graphic").clientWidth;
			const rem = parseInt(getComputedStyle(document.documentElement).fontSize);
			const graphWidth = stepWidth - (3 * (2 * rem));

			let chart  = LineChart(data, {
				x: d => d.label,
				y: d => d.value,
				yLabel: "↑ Uitgaven per jaar per inwoner(€)",
				width: graphWidth,
				height: (graphWidth / 3) * 1.5,
				xType: d3.scaleLinear
			});

			this.$refs.graphic.style.height = (graphWidth / 3) * 1.5;
			this.$refs.graphic.innerHTML = chart.innerHTML;

		},

		initScrollama () {
			// initialize the scrollama
			var scroller = scrollama();

				// find the halfway point of the initial viewport height
				// (it changes on mobile, but by just using the initial value
				// you remove jumpiness on scroll direction change)
				var midpoint = Math.floor(window.innerHeight * 0.5) + "px";
				// 1. setup the scroller with the bare-bones options
				//    this will also initialize trigger observations
				// 2. bind scrollama event handlers (this can be chained like below)

				let steps = this.$refs.scroll.querySelectorAll('.knd-step');

				scroller
					.setup({
						step: steps,
						debug: false,
						offset: .7
					})
					.onStepEnter(this.handleStepEnter)
					.onStepExit(this.handleStepExit);
		},

		// scrollama event handlers
		handleStepEnter(response) {
			// response = { element, direction, index }

			let el = response.element;
			let topic = el.dataset.topic;
			let title = el.dataset.title;
			let step = el.dataset.step;

			let index = this.story.stepper.findIndex(d => d.step === step);

			this.$store.dispatch('updateStep', 
				{topic, step, title, content: this.story.stepper[index]}
			);


			// add to color to current step
			response.element.classList.add("is-active");
		},

		handleStepExit(response) {
			console.log(response);
			// remove color from current step
			response.element.classList.remove("is-active");
		},

		loopObject(start, prop) {
			if(!start[prop]) {
				console.log(prop, ' does not exist');
				return '';
			}
			return start[prop];
		},

		output_text(text) {
			if(!text) return;
			return text.replace(/{{([^}]*)}}/g, (match, capt) => {
				let arr = capt.split('.');
				let start = this;
				for(var i = 0; i < arr.length; i++) {
					start = this.loopObject(start, arr[i])
				}

				start = start.toString().replace(".", ",");
				return start
			})    
		}    

	}
}
</script>
